import actions from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-documents/actions';

export default () => ({
    state: {},
    actions: {
        ...actions,
    },
});